import { css } from '@emotion/react';

import React from 'react';

import { Spacing } from 'chatie-design-system';

import { CSSProps } from '../../utils/misc';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const contentCSS = css`
  padding: ${Spacing.medium}px;
`;

const Content = ({ className, children }: Props & CSSProps) => {
  return (
    <div css={contentCSS} className={className}>
      {children}
    </div>
  );
};

export default Content;

const outerContentCSS = css`
  margin-left: -${Spacing.medium}px;
  margin-right: -${Spacing.medium}px;
`;

export const OuterContent = ({
  className,
  children,
  style = {},
}: Props & CSSProps) => {
  return (
    <div css={outerContentCSS} className={className} style={style}>
      {children}
    </div>
  );
};
